// extracted by mini-css-extract-plugin
export var cardIcon = "_4o-4";
export var checkboxCard = "_4o-0";
export var checkboxCardSelected = "_4o-1";
export var disabled = "_4o-2";
export var outerBorder = "_4o-3";
export var spacerMedium = "_4o-7";
export var spacerSmall = "_4o-6";
export var spacerXsmall = "_4o-5";